import { defineMessages } from '@sm/intl';

export default defineMessages({
  MY_ACCOUNT: {
    id: 'getUserLinks.myAccount',
    defaultMessage: 'My Account',
    description:
      '[Type: Label][Vis.: high] - This is the My account dropdown on the header.',
  },
  MY_TEAM: {
    id: 'getUserLinks.myTeam',
    defaultMessage: 'My Team',
    description:
      '[Type: Label][Vis.: high] - This is the My teams section of the userdrop down.',
  },
  LIBRARY: {
    id: 'getUserLinks.library',
    defaultMessage: 'Library',
    description:
      '[Type: Label][Vis.: high] - This is the Library link in the userdrop down.',
  },
  CONTACTS: {
    id: 'getUserLinks.contacts',
    defaultMessage: 'Contacts',
    description:
      '[Type: Label][Vis.: high] - This is the contacts link in the userdrop down.',
  },
  BENCHMARKS: {
    id: 'getUserLinks.benchmarks',
    defaultMessage: 'Benchmarks',
    description:
      '[Type: Label][Vis.: high] - This is the benchmarks link in the userdrop down.',
  },
  SIGN_OUT: {
    id: 'getUserLinks.sign_out',
    defaultMessage: 'Sign Out',
    description:
      '[Type: Label][Vis.: high] - This is the sign out link in the userdrop down.',
  },
});
